import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../config';
import useToken from '../../useToken';
import './RatingComponent.css';

export const StarsRow = ({ value = 0, size = 16 }) => {
	const score = Math.max(0, Math.min(5, Number(value) || 0));
	return (
		<span className="stars-row" aria-label={`${score} de 5`}>
			{Array.from({ length: 5 }, (_, idx) => {
				const filled = idx < Math.round(score);
				return (
					<svg
						key={idx}
						className={'stars-row__star' + (filled ? ' is-filled' : '')}
						width={size}
						height={size}
						viewBox="0 0 24 24"
						aria-hidden="true"
					>
						<path d="M12 3.2l2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 16.4 6.8 19.2l1-5.8L3.6 9.3l5.8-.8L12 3.2z"/>
					</svg>
				);
			})}
		</span>
	);
};

const formatRatingDate = (value) => {
	if(!value) return '';
	const date = new Date(value);
	if(Number.isNaN(date.getTime())) return '';
	return date.toLocaleDateString('es-MX', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	});
};

const RatingListModal = ({ idPost, onClose }) => {
	const { token } = useToken();
	const [ratings, setRatings] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (idPost && token) {
			fetch(`${baseUrl}Post/ratings/${idPost}`, {
				headers: {
					'Authorization': `Bearer ${token}`,
				}
			})
			.then(res => res.json())
			.then(data => {
				setRatings(data.data || []);
				setLoading(false);
			})
			.catch(() => setLoading(false));
		}
	}, [idPost, token]);

	const avg = ratings.length
		? ratings.reduce((sum, r) => sum + (Number(r.rating) || 0), 0) / ratings.length
		: 0;

	return (
		<div className="rating-modal-bg" onClick={onClose}>
			<div className="rating-modal ratings-list-modal" onClick={(e)=> e.stopPropagation()}>
				<div className="rating-modal-header">
					<div>
						<p className="rating-modal-kicker">Opiniones</p>
						<h3>Calificaciones del almacén</h3>
					</div>
					<button type="button" className="close-rating-modal" onClick={onClose} aria-label="Cerrar">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
							<path d="M18 6L6 18M6 6l12 12"/>
						</svg>
					</button>
				</div>

				{loading && <div className="loading-ratings">Cargando calificaciones…</div>}

				{!loading && ratings.length === 0 && (
					<div className="no-ratings">
						<div className="no-ratings__icon" aria-hidden="true">
							<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
								<path d="M12 3.2l2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 16.4 6.8 19.2l1-5.8L3.6 9.3l5.8-.8L12 3.2z"/>
							</svg>
						</div>
						<p>No hay calificaciones aún.</p>
						<span>Cuando los clientes evalúen este almacén, aparecerán aquí.</span>
					</div>
				)}

				{!loading && ratings.length > 0 && (
					<>
						<div className="ratings-summary">
							<div className="ratings-summary__score">
								<strong>{avg.toFixed(1)}</strong>
								<span>de 5</span>
							</div>
							<div className="ratings-summary__meta">
								<StarsRow value={avg} size={18}/>
								<span>{ratings.length} {ratings.length === 1 ? 'calificación' : 'calificaciones'}</span>
							</div>
						</div>
						<div className="ratings-list">
							{ratings.map((r, i) => (
								<article key={r.idRating || i} className="rating-item">
									<div className="rating-item__head">
										<StarsRow value={r.rating} size={15}/>
										<span className="rating-item__score">{Number(r.rating || 0).toFixed(1)}</span>
									</div>
									<p className={'rating-comment' + (!r.comment ? ' rating-comment--empty' : '')}>
										{r.comment || 'Sin comentario'}
									</p>
									<div className="rating-item__foot">
										<span className="rating-date">{formatRatingDate(r.createdAt)}</span>
									</div>
								</article>
							))}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default RatingListModal;
